import React, { useState , useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import {
	Box,
	Typography,
	Switch,
	IconButton,
	MenuItem,
	FormControl,
	Select,
	Card,
	CardContent,
	Divider,
	TextField,
	Autocomplete,
	Chip
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ButtonTheme from '../../../components/ThemeButton/ThemeButton';
import ApiService from '../../../functions/apiService';
import { toast } from 'react-toastify';
import moment from 'moment';
import { Row , Col } from 'react-bootstrap';

const ViewEntityModal = ({ viewEntityModal, setViewEntityModal , data}) => {
	const [entities , setEntities] = useState([]);
	const [viewAttributeModal , setViewAttributeModal] = useState(false);
	const [attributes , setAttributes] = useState([]);

	const getEntities = () => {
		ApiService.post('/inventory/get-inventory-entity', {
			type: data?.type || 'item',
			...(data?.type
				? { location_id: data?.id }     
				: { item_location_id: data?.id }  
			)
		}).then((data) => {
			setEntities(data.data || [])
		}).catch((error) => {
			console.error(error);
		})
	}

	useEffect(()=>{
		getEntities()
	} , [])

	const getAttributes = (entitiesData) => {
		ApiService.post('/inventory/inventory-entity-attribute', {
			type: data?.type || 'item',
			...(data?.type
				? { loc_entity_id : entitiesData?.id }     
				: { item_entity_id : entitiesData?.id }  
			)
		}).then((data) => {
			setAttributes(data.data || [])
		}).catch((error) => {
			console.error(error);
		})
	}


	return (
		<>
			<Modal show={viewEntityModal} onHide={() => setViewEntityModal(false)} size="md">
				<Modal.Header closeButton>
					<Modal.Title>Entities</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Box className="p-2">
						<Box
							className="mb-3 px-3 py-2"
							sx={{
								display: 'flex',
								alignItems: 'center',
								border: '1px solid #cccccc',
								width: 'fit-content',
								gap: 1,
								boxShadow:'0px 0px 20px 0px rgba(0, 0 , 0 , 0.1)'
							}}
						>
							{data?.type == 'location' ? 
								<img src="/images/location-blue-new.svg" alt="location" style={{ height: 20, width: 20 }} />
								:
								data?.type == 'location_item' ? 
								<img src="/images/location-item.svg" alt="location" style={{ height: 20, width: 20 }} />
								:
								<img src="/images/location-blue.svg" alt="location" style={{ height: 20, width: 20 }} />
							}
							<Typography variant="subtitle1">{data?.location_description || data?.item?.item_description}</Typography>
						</Box>

						{entities && entities?.length > 0 ?
							<Card variant="outlined" className='mb-4' sx={{borderRadius:'8px' , maxHeight:'40vh' , overflow:'scroll' , scrollbarWidth:'none'}}>
								<CardContent sx={{padding:'0px' , '&:last-child': {
										paddingBottom: 0,
									},}}>
									{entities.map((item, index) => (
										<Box
											key={index}
											sx={{
												justifyContent: 'space-between',
											}}
										>
											<Box sx={{ display: 'flex', alignItems: 'center', gap: 2 , padding:'8px'}}>
												<img src="/images/entity-shade.svg" alt={item?.name} style={{ width: 20, height: 20 , marginLeft:'10px' }} />
												<Typography sx={{ fontWeight: 600 , minWidth:'190px' }}>{item?.entity?.name || ''}</Typography>
												
												<div style={{display:'flex' , gap:1}}>
													<Button size="sm" 
														style={{
															minWidth:'140px' , 
															marginLeft:'10px' , 
															borderRadius:'20px' ,
															border:'1px solid #2B3F6C' , 
															backgroundColor:'#EAECF0',
															color:'#2B3F6C'
														}}
														onClick={() => {
															setViewAttributeModal(true)
															getAttributes(item)
														}}
														>
															<img src='/images/blue-eye.svg' style={{marginRight:'4px'}}/>
															Attributes ({item?.attributes_count})</Button>
												</div>
											</Box>

											{index < entities.length - 1 && <Divider sx={{ width: '100%' , backgroundColor:'#cccccc' }} />}
										</Box>
									))}
								</CardContent>
							</Card>
							: 
							<div className='d-flex flex-column align-items-center justify-content-center mb-3'>
								<img src='/images/blur-logo.png' style={{ height: 120, width: 150 }} />
								<span className='mt-4' style={{ color: '#555555' }}>
									No any entities
								</span>
							</div>
						}

					</Box>
				</Modal.Body>
			</Modal>

			{ <>
				<style>{`
					.custom-modal-lg {
						padding: 0px 20px;
					}
				`}</style>

				<Modal 
					show={viewAttributeModal} 
					onHide={() => setViewAttributeModal(false)}
					size="md"
					dialogClassName="custom-modal-lg"
				>
					<div
						style={{
							boxShadow: '0px 10px 60px rgba(0, 0, 0, 0.4)',
							borderRadius: '6px',
						}}
					>
						<Modal.Header closeButton>
							<Modal.Title>View Attributes</Modal.Title>
						</Modal.Header>
							<Modal.Body>
								{attributes && attributes?.length > 0 ?
									<Card variant="outlined" className='mb-2' sx={{borderRadius:'8px' , maxHeight:'70vh' , overflow:'scroll' , scrollbarWidth:'none'}}>
										<CardContent sx={{padding:'0px' , '&:last-child': {
												paddingBottom: 0,
											},}}>
											{attributes.map((item, index) => (
												<Box
													key={index}
													sx={{
														justifyContent: 'space-between',
													}}
												>
													<Box sx={{ display: 'flex', alignItems: 'center', gap: 2 , padding:'8px'}}>
														<img src="/images/entity-shade.svg" alt={item?.name} style={{ width: 20, height: 20 , marginLeft:'10px' }} />
														<Typography sx={{ fontWeight: 600 , minWidth:'210px' }}>{item?.attribute?.name || ''}</Typography>
														
														<Chip label={item?.value || ''} sx={{padding:'6px 20px' , backgroundColor:'#BF1D2D' , color:'#ffffff'}}/>
													</Box>

													{index < attributes.length - 1 && <Divider sx={{ width: '100%' , backgroundColor:'#cccccc' }} />}
												</Box>
											))}
										</CardContent>
									</Card>
									: 
									<div className='d-flex flex-column align-items-center justify-content-center mb-3'>
										<img src='/images/blur-logo.png' style={{ height: 120, width: 150 }} />
										<span className='mt-4' style={{ color: '#555555' }}>
											No any attributes
										</span>
									</div>
								}
							</Modal.Body>
					</div>
				</Modal>
			</> }
		</>
	);
};

export default ViewEntityModal;
